import { Stack, Typography } from "@mui/material";
import React from "react";

const DetailsGroup: React.FC<{
  title: string;
  mode: "column" | "row";
  children: React.ReactNode;
}> = ({ title, mode, children }) => {
  return (
    <Stack spacing={0.5} direction={mode} pt={2}>
      <Typography className="XProductDetails_Title">{title}</Typography>
      <Stack flex={1}>{children}</Stack>
    </Stack>
  );
};

export default DetailsGroup;
